import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  onboardNewCustomer,
  updateCustomer,
  fetchOnboardCustomerList,
  customerDetails,
  terminateCustomer,
  requestList,
  fetchSubCategories,
  booking,
  bookingDetails,
  agentDetails,
  checkout,
  requestList2,
} from "@/services/onboardCustomer";

@Module({
  namespaced: true,
})
export default class onboardCustomer extends VuexModule {
  //state
  public customerData = [];
  public requestListData = null;
  extendedData = {}
  //action
  @Action
  public async onboardNewCustomer(payload) {
    try {
      const data = await onboardNewCustomer(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async updateCustomer(payload) {
    try {
      const data = await updateCustomer(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchOnboardCustomerList() {
    try {
      const data = await fetchOnboardCustomerList();
      this.context.commit("setCustomerList", data.data.response);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async customerDetails(id) {
    try {
      const data = await customerDetails(id);
      let extendedData = {}
      if (data.data.response.extendedAttributes) {
        for (const [key, value] of Object.entries(
          data.data.response.extendedAttributes
        )) {
          if (key == "firstLogin") continue;
          if (typeof value == 'object') continue;
          extendedData[key] = value;
        }
      }
      this.context.commit("setExtendedData", extendedData)

      return data.data.response;
    } catch (error) {
      throw error;
    }
  }
  @Action({ rawError: true })
  public async terminateCustomerAction(payload) {
    try {
      const response = await terminateCustomer(payload);
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
  @Action
  public async requestListAction(payload) {
    try {
      const data = await requestList(payload.id);
      this.context.commit("SET_REQUEST_LIST", data.data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async requestList2Action(payload) {
    try {
      const data = await requestList2(payload.id);
      this.context.commit("SET_REQUEST_LIST", data.data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchSubCategoriesAction(payload) {
    try {
      const data = await fetchSubCategories(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async bookingAction(payload) {
    try {
      const data = await booking(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async bookingDetailsAction(payload) {
    try {
      const data = await bookingDetails(payload);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async agentDetailsAction(payload) {
    try {
      const response = await agentDetails(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async checkoutAction(payload) {
    try {
      const response = await checkout(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  //mutation
  @Mutation
  public setCustomerList(data: any) {
    this.customerData = data;
  }
  @Mutation
  public SET_REQUEST_LIST(data: any) {
    this.requestListData = data;
  }
  @Mutation
  public setExtendedData(data: any) {
    this.extendedData = data;
  }

  //getters
}
